"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ConceptMap_Unmapped = exports.ConceptMap_UnmappedModeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_canonical_1 = require("../Scalar/RTTI_canonical");
var ConceptMap_UnmappedModeKind;
(function (ConceptMap_UnmappedModeKind) {
    ConceptMap_UnmappedModeKind["_provided"] = "provided";
    ConceptMap_UnmappedModeKind["_fixed"] = "fixed";
    ConceptMap_UnmappedModeKind["_otherMap"] = "other-map";
})(ConceptMap_UnmappedModeKind = exports.ConceptMap_UnmappedModeKind || (exports.ConceptMap_UnmappedModeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_ConceptMap_Unmapped = t.recursion('IConceptMap_Unmapped', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        mode: (0, EnumType_1.createEnumType)(ConceptMap_UnmappedModeKind, 'ConceptMap_UnmappedModeKind'),
        _mode: RTTI_Element_1.RTTI_Element,
        code: RTTI_code_1.RTTI_code,
        _code: RTTI_Element_1.RTTI_Element,
        display: t.string,
        _display: RTTI_Element_1.RTTI_Element,
        url: RTTI_canonical_1.RTTI_canonical
    });
});
//# sourceMappingURL=RTTI_ConceptMap_Unmapped.js.map